import {
	OldTimeRegistrationTargetSuggestions,
	TimeRegistrationTargetSuggestions,
} from '../time-registration-target-suggestions/TimeRegistrationTargetSuggestionsFetch';

export type TimeRegInput = {
	node: {
		task: {
			id: string;
		};
		project: {
			id: string;
		};
		idleTime: {
			id: string;
		};
	};
};

export function suggestionsWithoutTimeRegs(
	timeRegsForPeriod: TimeRegInput[],
	validTimeRegistrationSuggestions: TimeRegistrationTargetSuggestions | OldTimeRegistrationTargetSuggestions
): boolean {
	const taskIds: string[] = timeRegsForPeriod.filter(timeReg => timeReg.node.task?.id).map(timeReg => timeReg.node.task?.id);

	const projectIds: string[] = timeRegsForPeriod
		.filter(timeReg => timeReg.node.project?.id)
		.map(timeReg => timeReg.node.project?.id);

	const idleTimeIds: string[] = timeRegsForPeriod
		.filter(timeReg => timeReg.node.idleTime?.id)
		.map(timeReg => timeReg.node.idleTime?.id);

	let hasSuggestionWithoutTimeReg = false;

	validTimeRegistrationSuggestions?.forEach(suggestion => {
		if (suggestion) {
			const taskHasTimeReg = suggestion.task?.id ? taskIds.includes(suggestion.task?.id) : false;
			const projectHasTimeReg = suggestion.project?.id ? projectIds.includes(suggestion.project?.id) : false;
			const idleTimeHasTimeReg = suggestion.idleTime?.id ? idleTimeIds.includes(suggestion.idleTime?.id) : false;

			// If we did not match any of the ids, then we have a suggestion without an existing time registration
			if (!(taskHasTimeReg || projectHasTimeReg || idleTimeHasTimeReg)) {
				hasSuggestionWithoutTimeReg = true;
			}
		}
	});

	return hasSuggestionWithoutTimeReg;
}
